module.exports = __webpack_public_path__ + "static/keyboardshortcut-container-do-2a37c7dfd8a34a2ab4d4e3fba103d5a6.png";